export default function HOME() {

  $(() => {
    
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'information':{
        button:{
          disp: true,
          text: '<i class="fa fa-caret-right" />すべて見る',
          attr:{
            class: 'button button-primary visible-xsmall button-round button-large'
          }
        },
        title:{
          html: false // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body,$thumb){
          $this.empty()
          const $item_body = $('<div/>',{class:'item-body'})
          $this.append($thumb).append($item_body)
          $item_body
            .append( $date )
            .append( $catetitle )
            .append( $title.append($new) )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        },
        cb($block) {
          const $head = $('<div/>',{class:'p-informationBlock__head'})
          $('.p-informationBlock__title',$block).wrapInner('<span/>').prependTo($head)
            .getCatList({content: 'information',blockClass: 'p-informationBlock__catlist',method:'after'})
          $('<a />',{href:'/information/',class:'button button-primary button-round hidden-xsmall button-large'}).html('<i class="fa fa-caret-right">&nbsp;</i>すべて見る').appendTo($head)
          if($.UA.is_pc || !$('html').hasClass('ui-mobile')) $block.find('.element_block').prepend($head)
          else $block.removeClass('homeBlock').prepend($head)
        }
      },
    }))
  
  });
}